import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppSettings, AppSettingsState } from './types';

const initialState = {
	versionFetchIntervalSeconds: 900, // 15 min by default
	defaultDebounceMs: 300
} as AppSettingsState;

const appSettingsSlice = createSlice({
	name: 'appSettings',
	initialState,
	reducers: {
		initializeSettings(state, action: PayloadAction<AppSettings>) {
			return {
				...state,
				...action.payload
			};
		}
	}
});

export const { initializeSettings } = appSettingsSlice.actions;

export default appSettingsSlice;
